import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, EMPTY, Observable, tap, throwError } from 'rxjs';
import { AppConfigService } from '../services/app-config.service';
import { SessionService } from '../services/session.service';

@Injectable()
export class RequestErrorInteceptor implements HttpInterceptor {
    constructor(
        private sessionService: SessionService,
        private appConfigService: AppConfigService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 498  && request.url.startsWith(this.appConfigService.getConfig().apiUrl)) {
                    this.sessionService.hideLoading();
                    this.sessionService.hideProcessing();
                    this.sessionService.showErrorDialog('Session has expired.');
                    this.sessionService.logout();
                    return EMPTY;
                } else {
                    throw(error);
                }
            }));
    }
}
